<div class="modal-header">
    <h4 class="modal-title">
        <i data-feather="plus"></i> Rezerve {{data ? 'Güncelle' : 'Ekle'}}
    </h4>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<form [formGroup]="certificateForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-xl-6 col-md-6 col-sm-12">
                <label for="company">Firma Seç</label>
                <ng-select [items]="companies" bindValue="id" bindLabel="companyName"
                    formControlName="companyId"></ng-select>
            </div>

            <div class="col-xl-6 col-md-6 col-sm-12">
                <label for="company">Rezerv No</label>
                <input type="text" class="form-control" id="basicInput" mask="000000000" formControlName="reservationNo"
                    placeholder="Rezerv no gir." />
                <div *ngIf="certificateForm.controls['reservationNo'].invalid && certificateForm.controls['reservationNo'].touched"
                    class="text-danger">
                    Geçerli bir rezervasyon numarası giriniz (örn: 202500001).
                </div>
            </div>

            <div class="col-xl-6 col-md-6 col-sm-12" *ngIf="isSeriesAdd">
                <label for="company">Bitiş Rezerv No</label>
                <input type="text" class="form-control" id="basicInput" mask="000000000"
                    formControlName="endReservationNo" placeholder="Rezerv no gir." />
                <div *ngIf="certificateForm.controls['endReservationNo'].invalid && certificateForm.controls['endReservationNo'].touched"
                    class="text-danger">
                    Geçerli bir rezervasyon numarası giriniz (örn: 202500001).
                </div>
            </div>
        </div>
    </div>
</form>
<div class="modal-footer d-flex" [ngClass]="!data ? 'justify-content-between' : 'justify-content-end'">
    <div class="custom-control custom-control-primary custom-switch" *ngIf="!data">
        <p class="mb-50">Seri Ekle</p>
        <input type="checkbox" class="custom-control-input" id="customSwitch3" (change)="toggleSeries()" />
        <label class="custom-control-label" for="customSwitch3"></label>
    </div>

    <div class="row">
        <button type="button" class="btn btn-secondary mr-1" (click)="closeModal()">İptal</button>
        <button type="submit" class="btn btn-primary" [disabled]="certificateForm.invalid"
            (click)="onSubmit()">Kaydet</button>
    </div>
</div>